const TabButtonGroup = ({ children }) => {
    return (
        <div className="bg-bluegray-300 dark:bg-ddark inline-block px-4 py-1 rounded-lg">
            { children }
        </div>
    )
}

export default TabButtonGroup